import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class LLMTestResultsByExecutionService extends BaseService {
  constructor() {
    super(constants.GET_LLM_RESULTS_BY_EXECUTION_ID_DATA, 'llmResultsByExecutionIdStatus');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    return this.getClient('aiadmin').get(`effectiveness/execution/${payload.executionId}`, { headers });
  }

  handleResponse(response, event) {
    const { data } = response;
    if (data.status === 'success') {
      const { payload } = utils.buildRequestPartsFromPayload(event);
      Framework.getStoreRegistry().getStore('effectivenessData').setExecutionResults(data, payload?.executionId);
    }
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
